import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPaymentCheck, getPaymentPlans, getZiinaUser } from '../../../api/payment/paymentServices';



export const getPaymentPlansThunk = createAsyncThunk(
  'payment/getPaymentPlans',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getPaymentPlans();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getPaymentCheckThunk = createAsyncThunk(
  'payment/getPaymentCheck',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getPaymentCheck();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getZiinaUserThunk = createAsyncThunk(
  'payment/getZiinaUser',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getZiinaUser();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
 